class CookieDependencyConfigurationObject {
    /**
     *
     * @param selector
     * @param callbackConsentFn optional function to call after given consent
     * @param callbackRevokedFn optional function to call after revoked consent
     */
    constructor(selector, callbackConsentFn, callbackRevokedFn) {
        this.selector = selector
        this.callbackConsentFn = callbackConsentFn
        this.callbackRevokedFn = callbackRevokedFn
    }
}

/**
 * Initializes all CookieConsentContent elements on the page
 */
export default function initializeCookieDependencyConfiguration() {
    let configurationForElements = []

    // for all forms add recaptcha script on consent or reload page when revoked
    configurationForElements.push(
        new CookieDependencyConfigurationObject(
            '.js-cookie-dependency__form',
            function () {
                if (!window.hasReCaptchaAPI) {
                    let m = document.createElement('script')
                    m.async = 1
                    m.defer = 1
                    // siteKey is set by src/Packages/Application/Wegmeister.Recaptcha/Resources/Private/Form/CaptchaV3.html
                    m.src = 'https://www.google.com/recaptcha/api.js?render=' + siteKey + '&onload=grecaptchaOnload'
                    document.body.appendChild(m)
                    window.hasReCaptchaAPI = true
                }
            },
            function () {
                location.reload()
            }
        )
    )

    return configurationForElements
}
